<template>
    <div class="container-fluid bStore_orders">
        
        <!-- Content for the sales page goes here -->
        <div class="row">
            <div class="col-1">
                <button class="btn btn-info" id="AddOrder" @click.prevent="openCreateOrder">{{ lang.bsord_add_order }}</button>
            </div>
            <div class="col-10">
                <input type="text" v-model="inputQuery" :placeholder="lang.bsord_search_ph" class="form-control"/>
            </div>
            <div class="col-1">
                <a class="btn btn-light" @click.prevent="openSettings()"><i class="fa fa-cog"></i></a>
            </div>
            <div class="col-12">
                <table-order :key="refreshKey" @orderSelected="openEditOrder"></table-order>
            </div>
        </div>
        <!-- modal lateral-->
        <modalLateral>
            <component v-bind:is="m.component" ></component>
        </modalLateral>

        <!-- Order form modal (vue-js-modal) -->
        <modal name="order-form-modal" :width="900" :height="heightModal" :scrollable="false" class="order-modal-viewport">
            <OrderForm :setting="infoSetting" :orderData="selectedOrder" :productosGrouped="productosGrouped" @save="handleSaveOrder" @cancel="handleCancelOrder" />
        </modal>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
import tableOrder from "./components/orders/tableOrders.vue";
import modalLateral from '@/core/plugins/themeModalLateral/modalLateral';
import bStore_setup from "./components/setup/bStore_setup.vue";
import OrderForm from "./components/orders/OrderForm.vue";
export default {
    components: {
        'table-order': tableOrder,
        modalLateral,
        bStore_setup,
        OrderForm,
    },
    data(){
        return {
            lang: {
                bsord_add_order: '',
                bsord_search_ph: '',
                bsord_item_required: '',
            },
            // Data properties for the sales page
            inputQuery: '',
            m: {
                show: false,
                component: '',
                data: []
            },
            selectedOrder: null,
            productos: [],
            productosGrouped: [],
            loadingProductos: false,
            // numeric modal height in px (viewport minus padding)
            heightModal: (typeof window !== 'undefined') ? (window.innerHeight - 80) : 600,
            refreshKey: 0, // used to force re-render of tableOrder if needed
            apis: null, // to store API endpoints
            infoSetting: {}, // to store order settings info
        };
    },
    created(){
        let t = this;
        this.lang = this.$store.getters['ModApps/Marketea/lang'];
        // prepare API routes used to fetch products if store is empty
        try{
            let urlApis = t.$store.getters['ModApps/Marketea/urlApis'];
            t.apis = urlApis.bStore;
        }catch(e){
            t.apis = null;
        }
    },
    computed: {
        ...mapGetters("ModApps/Marketea", {
            langGetter: "lang",
        }),
    },
    mounted(){
        this.get_bStoreSetting();
        this.getProductos();
        // keep modal height updated on resize
        this._onResize = () => { this.heightModal = window.innerHeight - 80; };
        window.addEventListener('resize', this._onResize);
    },
    beforeDestroy(){
        if(this._onResize) window.removeEventListener('resize', this._onResize);
    },
    watch: {
        langGetter() {
            this.lang = this.$store.getters['ModApps/Marketea/lang'];
        },
    },
    methods: {
        // Methods for handling sales page functionality
        openSettings() {
            let t = this;
            this.$store.commit('ModApps/Marketea/set_menuTab_bStore', 'orders');
            t.m.show= true;
            t.m.component= 'bStore_setup';
            t.m.data=[];
            t.$store.commit('core/setOpenModal', t.m);
        },
        // Open modal in create mode
        openCreateOrder(){
            this.selectedOrder = null;
            // show modal registered as 'order-form-modal'
            if(this.$modal && typeof this.$modal.show === 'function'){
                this.$modal.show('order-form-modal');
                // ensure modal overlay is above global header
                this.$nextTick(() => { setTimeout(() => { setOverlayZ(1000000); }, 50); });
            }
        },
        // Open modal in edit mode with selected order
        openEditOrder(order){
            this.selectedOrder = order || null;
            if(this.$modal && typeof this.$modal.show === 'function'){
                this.$modal.show('order-form-modal');
                this.$nextTick(() => { setTimeout(() => { setOverlayZ(1000000); }, 50); });
            }
        },
        async getProductos(){
            // Build productos grouped by category using existing store data
            this.loadingProductos = true;
            try{
                // Try to read categories with products from store (pattern used in other components)
                let listCat = this.$store.getters['ModApps/Marketea/get_bStore_listCat'] || [];

                // If the store has no categories, try to fetch from API (same endpoint used by productList.getList)
                if((!listCat || listCat.length===0) && this.apis){
                    const urlService = this.apis.get(0);
                    // build basic params (can be minimal)
                    const params = {
                        user_id: window.master_client,
                        org_id: window.localorgdata,
                        pusher_id: (typeof pusher !== 'undefined' && pusher && pusher.connection)? pusher.connection.socket_id : null,
                        rows: 0,
                        filter_group: [],
                        filter_name: null,
                        filter_status: [0,1],
                        ordenKey: 'orden',
                        ordenVal: 'ASC',
                    };
                    // @ts-ignore
                    const response = await window.master.post(urlService, params);
                    if(response && response.data && response.data.list && response.data.list.data){
                        listCat = response.data.list.data;
                        // persist in store for other components
                        this.$store.commit('ModApps/Marketea/set_bStoreValStorage', { key: 'bStore_listCat', val: listCat });
                        if(listCat.length>0){
                            this.$store.commit('ModApps/Marketea/set_bStoreValStorage', { key: 'bStore_catActive', val: listCat[0] });
                        }
                    }
                }

                // Map to required structure
                const grouped = (listCat || []).map(cat => {
                    const products = (cat.products || []).map(p => ({
                        id: p.id || p.product_id || 0,
                        product_name: p.product_name || p.name || p.title || '',
                        price: Number(p.price) || 0,
                        category_id: cat.id,
                        category_name: cat.name || cat.cat_name || '',
                    }));
                    return {
                        category_id: cat.id,
                        category_name: cat.name || cat.cat_name || '',
                        products,
                    };
                });
                this.productosGrouped = grouped;
                // flatten
                this.productos = grouped.flatMap(g => g.products.map(p => ({ ...p })));
            }catch(e){
                console.error('getProductos error', e);
                this.productos = [];
                this.productosGrouped = [];
            }finally{
                this.loadingProductos = false;
            }
        },
        normalizeItems(orderItems){
            // Ensure each item has consistent structure and types
            return (orderItems || []).map(item => ({
                id: item.id || null,
                order_id: item.order_id || null,
                product_id: item.product_id || null,
                product_name: item.product_name || '',
                price: Number(item.price) || 0,
                quantity: Number(item.quantity) || 0,
                taxOpc: Number(item.taxOpc) || 0,
                total: Number(item.total) || 0,
                note_item: item.note_item || '',
            }));
        },
        normalizeOrderData(orderData){
            // This function can be used to ensure orderData has a consistent structure before saving
            // For example, you could set default values or transform fields as needed
            let items = this.normalizeItems(orderData.items || []);
            if(items.length === 0){
                return false;
            }
            return {
                id: orderData.id || null,
                customer_name: orderData.customer_name || '',
                customer_lastname: orderData.customer_lastname || '',
                customer_phone: orderData.customer_phone || '',
                customer_email: orderData.customer_email || '',
                order_source: orderData.order_source || '',
                order_items: this.normalizeItems(orderData.items || []),
                subtotal: Number(orderData.subtotal) || 0,
                discount_total: Number(orderData.discount_total) || 0,
                total: Number(orderData.total) || 0,
                notes: orderData.notes || '',
                status: orderData.status || 'pending',
                // add other fields as needed
            };
        },
        // Handle save from OrderForm: simply hide modal and re-emit or process
        async handleSaveOrder(orderData){
            // Here you would process or emit the saved data;
            // we hide the modal as requested and emit an event for parent use if needed
            let formData = this.normalizeOrderData(orderData);
            if(!formData){
                console.log('orderData is invalid or has no items', orderData);
                alert(this.lang.bsord_item_required);
                return;
            }
            formData.user_id = window.master_client;
            formData.org_id = window.localorgdata;
            formData.pusher_id = (typeof pusher !== 'undefined' && pusher && pusher.connection)? pusher.connection.socket_id : null;
            const urlService = this.apis ? this.apis.set(11) : null; // setOrder
            console.log('Saving order with data:', formData);
            // @ts-ignore
            const response = await window.master.post(urlService, formData);
            if(response && response.ststus){
                // refresh orders list after save
                this.$emit('orderSaved', orderData);
            }
            if(this.$modal && typeof this.$modal.hide === 'function'){
                this.$modal.hide('order-form-modal');
                resetOverlayZ();
            }
        },
        handleCancelOrder(){
            if(this.$modal && typeof this.$modal.hide === 'function'){
                this.$modal.hide('order-form-modal');
                resetOverlayZ();
            }
        },
        get_bStoreSetting(){
            let t = this;
            let formData = {};
            formData.user_id = window.master_client;
            formData.org_id = window.localorgdata;
            formData.pusher_id = (typeof pusher !== 'undefined' && pusher && pusher.connection)? pusher.connection.socket_id : null;
            let urlService = t.apis.get(2)// getInfo
            window.master.post(urlService, formData)
            .then((response) => {
                console.log(urlService, response.data);
                if (response.data.status && response.data.currency && response.data.currency.meta_value) {
                    t.$store.commit('ModApps/Marketea/set_bStore_currency', response.data.currency.meta_value);
                }
                if (response.data.status) {
                    this.infoSetting = response.data.info || {};
                }
                this.get_currency();
            })
            .catch((error) => {
                console.log(error);
            });
        },
        get_currency(){
            let t = this;
            t.$store.commit("core/setLoadingModal", true);
            let formData = {};
            formData.user_id = window.master_client;
            formData.org_id = window.localorgdata;
            formData.pusher_id = (typeof pusher !== 'undefined' && pusher && pusher.connection)? pusher.connection.socket_id : null;
            let urlService = t.apis.get(4)// get_currency
            window.master.post(urlService, formData)
            .then((response) => {
                console.log(urlService, response.data);
                if (response.data.status && response.data.currency && response.data.currency.meta_value) {
                    t.$store.commit('ModApps/Marketea/set_bStore_currency', response.data.currency.meta_value);
                }
            })
            .catch((error) => {
                console.log(error);
            });
        },
    },
}

// helpers to temporarily raise/lower modal overlay z-index
function setOverlayZ(){
    try{
        const ov = document.querySelector('.v--modal-overlay');
        if(ov && !ov.classList.contains('order-top')){ ov.classList.add('order-top'); }
    }catch(e){ console.warn('setOverlayZ error', e); }
}
function resetOverlayZ(){
    try{
        const ov = document.querySelector('.v--modal-overlay');
        if(ov && ov.classList.contains('order-top')){ ov.classList.remove('order-top'); }
    }catch(e){ console.warn('resetOverlayZ error', e); }
}
</script>
<style>
/* Ensure this modal overlay appears above header when toggled */
.v--modal-overlay.order-top {
    z-index: 2147483647 !important;
}
.v--modal-overlay.order-top .v--modal-box {
    z-index: 2147483647 !important;
}
</style>
